import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpRequest, HttpEventType, HttpResponse} from '@angular/common/http';
import {AuthService} from '../service/auth.service';
import {environment} from '../../environments/environment';
import {ActivatedRoute, Params, Router} from '@angular/router';
import $ from 'jquery';
import {SharedService} from '../service/shared.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-profile-detail',
    templateUrl: './profile-detail.component.html',
    styleUrls: ['./profile-detail.component.css', './../people/people.component.css']
})
export class ProfileDetailComponent implements OnInit {

    api = environment.apiEndpoint;
    imgurl = environment.imageurl;
    token: string;
    slug: any;
    single_user_data: any[];
    image: any;
    fname: any;
    mobile: any;
    linkedin: any;
    ou: any;
    email: any;
    lname: any;
    edit = false;
    service_id: string;
    people_profile: any[] = [];
    linkdin: any;
    qans: any[] = [];
    all_all_sqqt: any[] = []
    company_logo: any = "";
    showEdit: boolean = false;
    user_slug: any;
    learinggoal: any[];
    lg_allqanda: any[] = [];
    openedit: boolean = true;
    service_name: string;

    // Image upload properties
    imageChangedEvent1: any = '';
    percentDoneOne: number = 0;
    imageoneuploaded: boolean = false;
    filename1: any = "Choose file";
    showCropper1: boolean = false; // Kept for backward compatibility
    user_role: string;
    profile_datavalue: any;
    u_role: any;
    href_linkedin: string;
    main_people: any;
    check_comapny_question: any;
    fk_brand_id: string;
    introduction: any;

    constructor(private authservice: AuthService, private ar: ActivatedRoute, private router: Router, private httpclient: HttpClient, private shared: SharedService, private sanitizer: DomSanitizer) {
        this.service_name = localStorage.getItem('service_name')
        if (localStorage.getItem('library')) {
            this.service_id = localStorage.getItem('library')

        }
        if (localStorage.getItem('auth-token')) {
            this.token = localStorage.getItem('auth-token')
        }

        if (localStorage.getItem('user_role')) {
            this.user_role = localStorage.getItem('user_role')
        }
    }

    ngOnInit() {
        this.fk_brand_id = localStorage.getItem("fk_brand_id");

        this.authservice.hideshowheader(false);
        this.token = localStorage.getItem('auth-token');
        this.ar.params.subscribe((params) => {
            this.slug = params['slug'];
            this.profiledata(this.token, this.slug);
            this.getAllDetails();
            this.getLearningGoal();
        });


    }

    profiledata(token, slug) {
        let libraryvalue = localStorage.getItem('library');
        this.httpclient.get(this.api + "auth/profilepage?token=" + token + "&slug=" + slug + "&service_slug=" + libraryvalue).subscribe((data: singleuser) => {
            this.single_user_data = data.profiledata;

            this.email = this.single_user_data['email'];
            this.image = this.single_user_data['overview_image'];
            this.u_role = this.single_user_data['role'];
            if (this.image != '') {
                this.imageoneuploaded = true;
            }
            this.fname = this.single_user_data['fname'];
            this.lname = this.single_user_data['lname'];
            this.mobile = this.single_user_data['mobile'];
            this.linkedin = this.single_user_data['linkdin'];

            if (this.single_user_data['linkdin']) {
                let url: string = '';
                if (!/^http[s]?:\/\//.test(this.single_user_data['linkdin'])) {
                    url += 'https://';
                }
                this.href_linkedin = url + this.single_user_data['linkdin'];
            }
            this.ou = this.single_user_data['own_user'];
        }, (error) => {
            console.log(error);
        })
    }

    getAllDetails() {
        this.httpclient.get(this.api + 'auth/profileinfo_for_people?token=' + this.token + '&user_slug=' + this.slug + "&service_slug=" + this.service_id).subscribe((data: people) => {
            this.people_profile = data.profile
            console.log('new', this.people_profile);
            this.mobile = this.people_profile['0'].mobile;
            this.linkdin = this.people_profile['0'].linkdin;
            if (this.people_profile['0'].linkdin) {
                let url: string = '';
                if (!/^http[s]?:\/\//.test(this.people_profile['0'].linkdin)) {
                    url += 'https://';
                }
                this.href_linkedin = url + this.people_profile['0'].linkdin;
            }
            this.qans = this.people_profile['0'].allqanda
            this.check_comapny_question = data.check_comapny_question
            this.user_slug = this.people_profile['0'].slug
            if (this.user_slug == localStorage.getItem('user_slug')) {
                this.showEdit = true;
                // if(this.openedit)
                // {

                //   this.edit=true;
                // }
            }

            for (let i = 0; i < this.qans.length; i++) {
                this.all_all_sqqt.push(this.qans[i].all_sqqt)
            }

            if (this.all_all_sqqt.length != 0) {
                if (this.all_all_sqqt['0'].length && this.all_all_sqqt['0']['0'].comapny_logo) {
                    this.company_logo = this.imgurl + "storage/company_img/resize_" + this.all_all_sqqt['0']['0'].comapny_logo
                }
            }

        })
    }


    editdiv() {
        if (this.edit == true) {
            window.location.reload();
        } else {
            this.edit = !this.edit;
        }
    }

    submitDetails() {
        const fd = new FormData()
        fd.append('mobile', this.mobile)
        fd.append('linkdin', this.linkdin)
        fd.append('user_slug', this.slug)
        fd.append('check_comapny_question', this.check_comapny_question)
        if (this.qans.length != 0) {
            fd.append('fk_service_id', this.qans[0].fk_service_id)
        }

        let check = ['Professional title', 'Current job', 'Work experience', 'Education', 'Personality', 'Expectations', 'single_line', 'multiple_line', 'Company'] //,'relevancy','slider'
        for (let i = 0; i < this.qans.length; i++) {
            console.log(this.qans[i]);
            for (let j = 0; j < check.length; j++) {
                if (check[j] == this.qans[i].sqa_questionheader) {
                    console.log($('#pe' + i).val())
                    fd.append('fk_qanda_id_' + i, this.qans[i].fk_qanda_id)
                    fd.append('questiontext_' + i, $('#pe' + i).val())
                }
                if (check[j] == this.qans[i].sqa_typeofquestion) {
                    console.log($('#pe' + i).val())
                    fd.append('fk_qanda_id_' + i, this.qans[i].fk_qanda_id)
                    fd.append('questiontext_' + i, $('#pe' + i).val())
                }
            }
            if (this.qans[i].sqa_typeofquestion == 'relevancy') {
                console.log($('input[name=' + 'pe' + i + ']' + ':checked').val());
                fd.append('fk_qanda_id_' + i, this.qans[i].fk_qanda_id)
                fd.append('questiontext_' + i, $('input[name=' + 'pe' + i + ']' + ':checked').val())
            }
            if (this.qans[i].sqa_typeofquestion == 'slider') {
                console.log($('input[name=' + 'pe' + i + ']' + ':checked').val());
                fd.append('fk_qanda_id_' + i, this.qans[i].fk_qanda_id)
                fd.append('questiontext_' + i, $('input[name=' + 'pe' + i + ']' + ':checked').val())
            }
        }

        let count = String(this.qans.length)
        fd.append('total_count', count)

        this.httpclient.post(this.api + "auth/insert_service_qanda_question_text?token=" + this.token, fd).subscribe((data) => {
            this.all_all_sqqt = []
            this.openedit = false
            this.editdiv()
            this.getAllDetails()
            this.profiledata(this.token, this.slug)
        }, (error) => {
            console.log(error)
        })
    }

    getLearningGoal() {
        this.httpclient.get(this.api + 'auth/profileinfo_learninggoals?token=' + this.token + '&service_slug=' + this.service_id + "&user_slug=" + this.slug).subscribe((data: learninggoal) => {
            this.introduction = data.introduction;
            this.learinggoal = data.learinggoal;
            for (let i = 0; i < this.learinggoal.length; i++) {
                this.lg_allqanda.push(this.learinggoal[i].allqanda)
            }
        })
    }

    SaveLearningGoal(i, pid, slid) {
        console.log($('#letext' + i).val())
        console.log(i, pid, slid)
        console.log($('input[name=' + 'le' + i + ']' + ':checked').val());
        let textbox_text = $('#letext' + i).val()
        let slider = $('input[name=' + 'le' + i + ']' + ':checked').val()

        const fd = new FormData()
        fd.append('fk_service_id', this.learinggoal[0].sl_serviceid)
        fd.append('fk_profile_id', pid)
        fd.append('fk_learning_goal_id', slid)
        fd.append('learning_goal_text', textbox_text)
        fd.append('answer_slider', slider)
        this.httpclient.post(this.api + 'auth/insert_service_learning_answer?token=' + this.token, fd).subscribe((data) => {
            console.log(data)

        })
    }

    fileChangeEventOne(event: any) {
        let data = event;
        console.log(data.target.files['0'])
        if (data.target.files['0'].size > 5242880) {
            alert('Max. Image size: 5MB For Profile Picture');
            return false;
        }
        this.imageChangedEvent1 = event;
        this.filename1 = event.target.files['0'].name;
        console.log(this.imageChangedEvent1, '1')
    }
    // Removed unused image cropper methods



        uploadImage() {
            if (this.imageChangedEvent1) {
                // Get the file from the event
                const file = this.imageChangedEvent1.target.files[0];

                // Create FormData and append the file directly
                const fdone = new FormData();
                fdone.append('overview_image', file);

                // Send the request
                const req = new HttpRequest('POST', this.api + "auth/update_profile_img?token=" + this.token, fdone, {
                    reportProgress: true,
                });

                this.httpclient.request(req).subscribe(event => {
                    if (event.type === HttpEventType.UploadProgress) {
                        // This is an upload progress event. Compute and show the % done:
                        this.percentDoneOne = Math.round(100 * event.loaded / event.total);
                        console.log(this.percentDoneOne);
                        if (this.percentDoneOne == 100) {
                            this.percentDoneOne = 0;
                            this.filename1 = "Choose file";
                            this.image = "";
                            this.imageoneuploaded = true;
                        }
                    } else if (event instanceof HttpResponse) {
                        this.profiledata(this.token, this.slug);
                        localStorage.setItem('overview_image', event.body['image']);
                    }
                });
            }
        }

    tomainpage() {
        location.reload();
        // window.location.href = 'profile-detail/2c3ec96e4f';
        // this.router.navigate(["/'profile-detail/2c3ec96e4f"]);
    }

    topMenu(v) {
        this.main_people = v
    }

    sanitize(url: string) {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
}

export interface singleuser {
    profiledata: any[];
}

export interface people {
    profile?: any;
    check_comapny_question: any
}

export interface learninggoal {
    introduction: any;
    learinggoal: any[],
    status?: any
}


export interface profile {
    profile: any[];
}
